<template>
  <div style="font-size: 1.5rem">
    <span v-if="itemState === 'NOT_AVAILABLE'" class="badge badge-danger">Vyprodáno</span>
    <span v-if="itemState === 'COMING_SOON'" class="badge badge-warning">Předobjednávka</span>
    <span v-if="itemState === 'NEW'" class="badge badge-info">Novinka</span>
  </div>
</template>
<script>
export default {
  name: "ItemBadge",
  props: ["itemState"],
};
</script>